export default __webpack_public_path__ + "static/media/icon-website-help.7c7e2e0c.svg";